import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionHeader, Pill } from "@/components/Brand";

export default function MySubmissions() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/surveys/me").then((r) => setItems(r.data));
  }, []);
  return (
    <div>
      <SectionHeader eyebrow="History" title="My Submissions" />
      <div className="space-y-2">
        {items.length === 0 && <div className="text-sm text-slate-500">No submissions yet.</div>}
        {items.map((s) => (
          <div key={s.id} className="wi-card p-4 flex items-center justify-between" data-testid={`submission-${s.id}`}>
            <div>
              <div className="font-semibold text-slate-900 text-sm">{s.ward_name} · Booth {s.booth_number}</div>
              <div className="text-xs font-mono text-slate-500">{s.submitted_at?.replace("T", " ").slice(0, 19)}</div>
            </div>
            <Pill tone="green">submitted</Pill>
          </div>
        ))}
      </div>
    </div>
  );
}
